import { InputAdornment, TextField, Typography } from '@material-ui/core';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core/styles';
import { Search } from '@material-ui/icons';
import * as React from 'react';
import MyButton from '../MyButton';
const styles = (theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'uppercase',
      marginBottom: '1rem'
    },
    heading: {
      textTransform: 'uppercase'
    },
    margin: {
      marginRight: '2rem',
      width: '25rem'
    },
    headerWrap: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '1rem'
    }
  });

interface IMainHeadingOwnProps {
  mainHeading: string;
  onSearch: (e) => any;
  searchPlaceholder: string;
  buttonText?: string;
  showButton: boolean;
  onClickButton?: () => any;
}
type IMainHeadingProps = IMainHeadingOwnProps & WithStyles<typeof styles>;

function MainHeading(props: IMainHeadingProps) {
  const { classes } = props;
  return (
    <div className={classes.headerWrap}>
      <Typography variant={'h6'} className={classes.heading}>
        {props.mainHeading}
      </Typography>
      <div>
        <TextField
          onChange={e => props.onSearch(e)}
          className={classes.margin}
          placeholder={props.searchPlaceholder}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            )
          }}
        />
        {props.showButton ? (
          <MyButton btnType={'yellow'} onClick={props.onClickButton}>
            {props.buttonText}
          </MyButton>
        ) : null}
      </div>
    </div>
  );
}

export default withStyles(styles)(MainHeading);
